import { useState, RefObject } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../common/auth/PermissionsContext';

interface Props {
  ksvSubmitRef: RefObject<HTMLButtonElement>;
  onIdentityCheck: () => void;
  ksvDoneError?: boolean;
  customerId?: number;
}

export function IdentityCheckMenuButton({
  ksvSubmitRef,
  onIdentityCheck,
  ksvDoneError,
  customerId,
}: Props) {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  const canViewIdentityCheck = hasPermission('IdentityCheck', 'View');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleKsvSubmit = () => {
    handleClose();
    ksvSubmitRef.current?.click();
    ksvSubmitRef.current?.scrollIntoView();
  };

  const handleIdentityCheck = () => {
    handleClose();
    onIdentityCheck();
  };

  return (
    <>
      <Button
        variant="contained"
        color={ksvDoneError ? 'error' : 'primary'}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        aria-controls={open ? 'ksv-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        {t('customers.identityCheck.checkIdentity')}
      </Button>
      <Menu
        id="ksv-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'ksv-menu-button',
        }}
      >
        <MenuItem onClick={handleKsvSubmit}>{t('customers.ksv.submitSearch')}</MenuItem>
        {canViewIdentityCheck && (
          <MenuItem onClick={handleIdentityCheck} disabled={!customerId}>
            {t('customers.identityCheck.fincredible')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
